import styled from 'styled-components'
import { H1 } from '../../typography'

interface RankCircleWrapperProps {
  width?: number
  themeKey: 'performanceCard' | 'leaderBoard'
}

export const RankCircleWrapper = styled.div<RankCircleWrapperProps>`
  background-color: ${({ theme, themeKey }) =>
    theme[themeKey].circleBackground};
  border-radius: 100%;
  width: ${({ width }) => width || '80'}px;
  height: ${({ width }) => width || '80'}px;
  position: relative;
  @media (max-width: 360px) {
    height: ${({ width }) => (width ? width - 10 : '70')}px;
  }
`

interface CircleProps {
  themeKey: 'performanceCard' | 'leaderBoard'
}

export const Circle = styled.div<CircleProps>`
  display: flex;
  transform: translate(8%, 8%);
  border-radius: 100%;
  box-shadow: 0 0 5px 0 ${(props) => props.theme[props.themeKey].circleShadow};
  width: 87%;
  height: 87%;
  background-color: ${(props) => props.theme[props.themeKey].circle};
  align-items: center;
`

export const Rank = styled(H1)`
  margin: auto;
`
